import React from 'react';
import { observer } from 'mobx-react-lite';
import { exchangeAmountByRate, userInfoStore } from '@pascal/pascal-core';
import { liveUpdateStore } from '../../store/liveUpdateStore';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';

const AllBets = observer(() => {
  const { allGamesLiveSpins } = liveUpdateStore;
  const t = useTranslation();

  return (
    <div className='allbets-wrraper'>
      <div className='allbets-item-title-row'>
        <div className='allbets-item-title-txt'>{t(TranslationKeys.Game)}</div>
        <div className='allbets-item-title-txt'>{t(TranslationKeys.RoundId)}</div>
        <div className='allbets-item-title-txt'>{t(TranslationKeys.Bet)}</div>
        <div className='allbets-item-title-txt'>{t(TranslationKeys.Win)}</div>
      </div>
      {allGamesLiveSpins.map((el) => {
        return (
          <div className='allbets-item-row' key={el.spinId}>
            <div className='allbets-item-row-inner'>
              <div className='allbets-item-col'>
                <span>{el.gameName}</span>
              </div>
              <div className='allbets-item-col'>
                <span>{el.spinId}</span>
              </div>
              <div className='allbets-item-col'>
                <span>
                  {exchangeAmountByRate(el).amount}
                  {userInfoStore.currencySymbolOrCode}
                </span>
              </div>
              <div className='allbets-item-col'>
                <span>
                  {exchangeAmountByRate(el).winAmount}
                  {userInfoStore.currencySymbolOrCode}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
});
export default AllBets;
